export default "__VITE_ASSET__ku3s2OgF__"